<template>
    <base-spinner :open="isloading"></base-spinner>
    <base-dialog title="Insufficient On-Hand" @close="closeDialog" :open="openInsufficientOnHandDialog">
        <template #default>
            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Manufacturer</th>
                            <th>Item</th>
                            <th>Description</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{{ partsList.manufacturer }}</td>
                            <td>{{ partsList.item }}</td>
                            <td>{{ partsList.itemdesc }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <p class="text-right">
                <strong>Quantity requested: <span class="text-danger">{{ partsList.requestedquantity }}</span></strong>
                <br />
                <strong>Quantity available: {{ partsList.stockquantity }}</strong>
            </p>

            <div class="table-responsive">
                <table class="table">
                    <thead>
                        <tr>
                            <td></td>
                            <td><strong>Your choices are</strong></td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <input type="radio" id="insfopt1" v-model="selectedOption" value="1" ref="defaultopt" @keypress.enter.prevent="selectOption" />
                            </td>
                            <td>
                                <label for="insfopt1">Check Other Locations</label>
                            </td>
                        </tr>
                        <tr v-if="showBackorder">
                            <td>
                                <input type="radio" id="insfopt2" v-model="selectedOption" value="2" @keypress.enter.prevent="selectOption" />
                            </td>
                            <td>
                                <label for="insfopt2">Backorder Remaining Qty</label>
                            </td>
                        </tr>
                        <tr v-if="showLogLostSale">
                            <td>
                                <input type="radio" id="insfopt3" v-model="selectedOption" value="3" @keypress.enter.prevent="selectOption" />
                            </td>
                            <td>
                                <label for="insfopt3">Log Lost Sale</label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="radio" id="insfopt4" v-model="selectedOption" value="4" @keypress.enter.prevent="selectOption" />
                            </td>
                            <td>
                                <label for="insfopt4">Cancel Remaining Qty</label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <input type="radio" id="insfopt5" v-model="selectedOption" value="5" @keypress.enter.prevent="selectOption" />
                            </td>
                            <td>
                                <label for="insfopt5">Cancel Item</label>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
        <template #actions>
            <button type="button" class="btn btn-sm btn-secondary" @click="closeDialog">
                Cancel
            </button>
            <button type="button" class="btn btn-sm btn-primary" @click.prevent="selectOption" :disabled="selectedOption === null" ref="defaultbtn">
                Select
            </button>
        </template>
    </base-dialog>
    <base-dialog title="Lost Sale Confirmation" @close="closeLogDialog" :open="openLogLostSaleDialog">
        <template #default>
            <p>The record of your lost sale has been <span :class="logLostSaleResult.class">{{ logLostSaleResult.message }}</span>.</p>
        </template>
        <template #actions>
        <button type="button" class="btn btn-sm btn-primary" @click="closeLogDialog">
            Ok
        </button>
        </template>
    </base-dialog>
</template>

<script>
import MixinCart from '../../../mixins/cart.js';
import axiosvl from "../../../axios/axios-vl.js";
// import { ref, onMounted } from 'vue'
import { mapGetters } from 'vuex';

export default {
    props: {
        openInsufficientOnHandDialog: {
            type: Boolean,
            required: true,
            default: false
        },
        partsList: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            default: 'add'
        },
        sourcePage: {
            type: String
        }

    },
    emits: [
        "closeInsOnHandDialog",
        "removeFromCart"
    ],
    mixins : [
        MixinCart
    ],
    data() {
        return {
            selectedOption: "1",
            openLogLostSaleDialog: false,
            logLostSaleStatus: '',
            isloading: false,
            product: {},
        }
    },
    computed: {
        ...mapGetters([
            'storefrontAttributes'
        ]),
        showBackorder() {
            if (this.storefrontAttributes.length > 0) {
                let storefrontBOsetting = this.storefrontAttributes.find(attribute => attribute.type === 'BKO').value;
                // console.log('storefrontBOsetting = ' + storefrontBOsetting);
                let customerBOsetting = this.$store.getters.getCustomerDetails.allowbackorder;
                // comment out hardcoded
                // customerBOsetting = 'Y';
                // console.log('customerBOsetting = ' + customerBOsetting);
                return storefrontBOsetting === 'Y' && customerBOsetting === 'Y';
            } else {
                return false;
            }
        },
        showLogLostSale() {
            if (this.storefrontAttributes.length > 0) {
                return this.storefrontAttributes.find(attribute => attribute.type === 'LLS').value === 'Y';
            } else {
                return false;
            }
        },
        logLostSaleResult() {
            if (this.logLostSaleStatus === 'OK') {
                return {
                    "class": "text-success",
                    "message": "logged"
                }
            } else {
                return {
                    "class": "text-danger",
                    "message": "not logged"
                }
            }
        }
    },
    methods: {
        selectOption() {
            let url = '';
            switch (this.selectedOption) {
                case "1":
                    url = '/order-entry-check-stock/' + this.partsList.manufacturer + '/' + this.partsList.item;
                    this.$emit("closeInsOnHandDialog");
                    this.$router.push(url);
                    break;
                case "2":
                    this.addToCart(true, false);
                    break;
                case "3":
                    this.logLostSale();
                    break;
                case "4":
                    this.addToCart(false, true);
                    break;
                case "5":
                    if (this.mode === 'update') {
                        this.$emit("removeFromCart", this.partsList.cartindex);
                    }
                    this.$emit("closeInsOnHandDialog", true);
                    break;
                default: 
                    break;
            }
        },
        logLostSale() {
            this.logLostSaleStatus = '';
            this.isloading = true;
            axiosvl.post(this.$store.getters['api/lost_log_sale'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": {"value": this.$store.getters.customer },
                        "EILOCN": {"value": this.partsList.location },
                        "EIMFGC": {"value": this.partsList.manufacturer },
                        "EIITMC": {"value": this.partsList.item },
                        "EIOQTY": {"value": this.partsList.requestedquantity },
                        "QTYAVL": {"value": this.partsList.stockquantity }
                    }
                }
            })
            .then((response) => {
                // console.log(response.data.webroutine.fields.RESULTCOD);
                // const RESULTCOD = response.data.webroutine.fields.RESULTCOD.value;
                // const RESULTCOD = 'ER';

                this.openLogLostSaleDialog = true;
                this.logLostSaleStatus = response.data.webroutine.fields.RESULTCOD.value;
                this.isloading = false;
                // if (RESULTCOD == 'OK'){
                //     this.logSucessClass = 'text-success';
                //     this.logMessage  = 'logged';
                // } else{
                //     this.logSucessClass = 'text-danger';
                //     this.logMessage  = 'not logged';
                // }
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
            });
        },
        closeLogDialog() {
            this.openLogLostSaleDialog = false;
        },
        addToCart(backordered, cancelRemainingQty) {
            this.$store.dispatch("message/clearKeyedMessage", this.sourcePage);
            this.isloading = true;

            axiosvl.post(this.$store.getters['api/product_details_uri'], {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },   
                    "fields": {
                        "EHCUST": { "value": this.$store.getters['customer'] },
                        "EIMFGC": { "value": this.partsList.manufacturer },
                        "EIITMC": { "value": this.partsList.item },
                    },   
                }
            })
            .then((response) => {
                const fields = response.data.webroutine.fields;

                if (fields.RESULTCOD.value === 'OK') {

                    let qty = this.partsList.requestedquantity;

                    if (cancelRemainingQty) {
                        // Option 4 - Add the remaining stock only
                        qty = fields.QTYAVL.value;
                    }

                    const linetotal = qty * fields.EIEXCP.value;

                    let isupdating = this.mode === 'update' ? true : false;

                    this.product = {
                        ID: fields.IMITMC.value,
                        linenumber: this.partsList.linenumber,
                        item: fields.IMITMC.value,
                        desc: fields.IMDESC.value,
                        manufacturer: fields.IMMFGC.value,
                        image: null,
                        quantity: qty,
                        corecharge: fields.EICORP.value,
                        yourprice: fields.EIEXCP.value,
                        listprice: fields.EILSTP.value,
                        shipping: 0,
                        linetotal: linetotal,
                        stockquantity: fields.QTYAVL.value,
                        backorder: backordered,
                        isupdating: isupdating
                    };

                    // console.log('this.product - ' + JSON.stringify(this.product));

                    let validationresult = this.addToCartValidation(this.product);

                    if (validationresult.status === 'OK') {
                        this.searchKeyword = '';
                        if (this.mode === 'update') {
                            this.$store.dispatch("cart/updateCart", this.product);
                        } else {
                            // setTimeout(() => {
                                this.$store.dispatch("cart/addToCart", this.product);
                                this.$emit("closeInsOnHandDialog", true);
                                this.isloading = false;
                            // }, 2000);
                        }
                    } else {
                        let storedmessages = [];
                        storedmessages.push(validationresult.message);

                        this.$store.dispatch("message/addKeyedMessage", {
                            "key": this.sourcePage,
                            "messages": storedmessages
                        });
                        
                        this.$emit("closeInsOnHandDialog", true);
                        this.isloading = false;
                    }

                }else{
                    this.$emit("closeInsOnHandDialog", true);
                    this.isloading = false;
                }
            })
            .catch((error) => {
                console.log("error - " + error);
                this.isloading = false;
                this.$emit("closeInsOnHandDialog", true);
            });
        },
        closeDialog() {
            this.$emit("closeInsOnHandDialog");
        }
    },
    // setup() {
    //     const defaultopt = ref(null);
    //     // Before the component is mounted, the value
    //     // of the ref is `null` which is the default
    //     // value we've specified above.
    //     onMounted(() => {
    //         // Logs: `Headline`
    //         console.log(defaultopt.value);
    //     });

    //     return {
    //         // It is important to return the ref,
    //         // otherwise it won't work.
    //         defaultopt,
    //     };
    // },
    watch: {
        openInsufficientOnHandDialog(newVal) {
            // console.log(newVal + ' - ' + this.$refs + ' - ' + this.$refs.defaultbtn);
            // console.dir(this.$refs)
            if (newVal) {
                this.selectedOption = "1";
                this.logLostSaleStatus = '';
                this.openLogLostSaleDialog = false;
                this.isloading = false;
            }
            // this.$refs.defaultopt.focus();
        }
    }
}
</script>
